module.exports = __webpack_public_path__ + "c34e4b3af0b2327888b4564232647fa4.pdf";